import {AbstractPmsApiService} from './abstract.service';
import {HouseAccount} from '../models';

/**
 * @class HouseAccountPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<HouseAccount>}
 */
export class HouseAccountPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/house-account(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @returns {HouseAccount}
     * @protected
     */
    newModel(attributes, ...params) {

        return new HouseAccount(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<HouseAccount>>}
     */
    get(params = {}, property = null) {

        const url = this.url({
            propertyId: property ? property.id : 0
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {HouseAccount} houseAccount
     * @param {Property} property
     * @returns {Promise.<HouseAccount>}
     */
    create(houseAccount, property) {

        const url = this.url({
            propertyId: property.id
        });

        return this.http
            .post(url, this.prepareToRequest(houseAccount), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    show(houseAccount, property) {

        const url = this.url({
            propertyId: property.id,
            id: houseAccount.id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {HouseAccount} houseAccount
     * @returns {Promise.<HouseAccount>}
     */
    update(houseAccount) {

        const url = this.url({
            propertyId: houseAccount.property_id,
            id: houseAccount.id
        });

        return this.http
            .put(url, this.prepareToRequest(houseAccount), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    prepareToRequest(houseAccount) {

        return houseAccount.toObject('id', 'name', 'is_private', 'ntmp_account');
    }

    updateStatus(houseAccount, status) {

        const url = this.url({
            propertyId: houseAccount.property_id,
            id: houseAccount.id
        }) + '/update-status';

        return this.http
            .post(url, {status}, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/house-account.service.js